<template>
  <div class="page">
    <div class="seiten-kopf">
      <router-link to="/einkaufsliste/kategorien" class="seiten-kopf-zurueck" aria-label="Zurück">
        <font-awesome-icon icon="fa-solid fa-arrow-left" />
      </router-link>
      <h1>Kategorie bearbeiten</h1>
    </div>

    <form class="zutat-form" @submit.prevent>
      <label for="bearbeiten-kategorie-name">Name</label>
      <div class="input-field">
        <input id="bearbeiten-kategorie-name" v-model="Name" type="text" placeholder="Kategoriename" />
      </div>

      <p v-if="Status" class="hint-message success">{{ Status }}</p>
      <p v-if="Fehlermeldung" class="error-message">{{ Fehlermeldung }}</p>

      <div class="button-row">
        <button type="button" class="btn btn-primary" @click="Speichern">Speichern</button>
        <router-link to="/einkaufsliste/kategorien" class="btn btn-secondary">Abbrechen</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { KategorieFinden, KategorieAktualisieren, KategorienLaden } from '../composables/useZutaten'

export default {
  name: 'KategorieBearbeitenView',
  data() {
    return {
      KategorieId: null,
      Name: '',
      UrspruenglicherName: '',
      Status: '',
      Fehlermeldung: ''
    }
  },
  async created() {
    await KategorienLaden()
    this.KategorieId = Number(this.$route.params.id)
    const Kategorie = KategorieFinden(this.KategorieId)
    if (Kategorie) {
      this.Name = Kategorie.Name
      this.UrspruenglicherName = Kategorie.Name
    }
  },
  methods: {
    async Speichern() {
      this.Fehlermeldung = ''
      const NeuerName = this.Name.trim()

      if (!NeuerName) {
        this.Fehlermeldung = 'Name darf nicht leer sein.'
        return
      }

      if (NeuerName === this.UrspruenglicherName) {
        this.Status = 'Keine Änderungen.'
        return
      }

      try {
        await KategorieAktualisieren(this.KategorieId, NeuerName)
        this.$router.push('/einkaufsliste/kategorien')
      } catch (Fehler) {
        this.Fehlermeldung = Fehler.message
      }
    }
  }
}
</script>

<style scoped>
.zutat-form {
  display: flex;
  flex-direction: column;
  max-width: 320px;
  margin-top: 16px;
}

.zutat-form label {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 0.9rem;
}
</style>
